/* __next_internal_client_entry_do_not_use__ CircleFilled auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/** @trackcomponent */ export var CircleFilled = createSVGIcon(/*#__PURE__*/ _jsx("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    fill: "currentColor"
}), "CircleFilled", {
    viewBox: "0 0 8 8",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
